import { useContext } from 'react';
import { LoaderContext } from '../Main';

export const useLoader = () => {
  const { loading, showLoading } = useContext(LoaderContext);
  return { loading, showLoading };
};
